<div class="sub-tasks-wrapper">
  <div class="mobile-app-bar">
    <h2 class="subtask-heading" translate>{{ subtask ? 'Edit' : 'Add' }} Sub-task</h2>
    <div class="mobile-app-bar__action-icon">
      <app-icon (click)="close()" iconName="close" size="16px"></app-icon>
    </div>
  </div>
  <form [formGroup]="form" action="">
    <div class="flex-row-start gap-12">
      <!-- Title -->
      <div class="input-group full-width-input --required">
        <label for="title" translate>Title</label>
        <input [placeholder]="'Enter Title' | translate" class="full-width-input" formControlName="title" id="title" name="title" type="text" />
        <app-form-error [control]="form.get('title')" [name]="'Title' | translate"></app-form-error>
      </div>
      <!-- Date -->
      <div class="input-group full-width-input --required">
        <label for="date" translate>Date</label>
        <app-date-picker-input [pastDatesSelection]="false" class="full-width-input" formControlName="date" id="date" name="date"></app-date-picker-input>
        <app-form-error [control]="form.get('date')" [name]="'Date' | translate"></app-form-error>
      </div>
    </div>
    <!-- Description -->
    <div class="input-group --required">
      <label for="description" translate>Description</label>
      <textarea [placeholder]="'Enter Description' | translate" formControlName="description" id="description" name="description" rows="3"></textarea>
      <app-form-error [control]="form.get('description')" [name]="'Description' | translate"></app-form-error>
    </div>

    <!--  Members  -->
    <div class="input-group --required">
      @if (taskType) {
        <label translate>Members</label>
      }

      @if (taskType === TasksType.Group) {
        <ng-select
          [items]="groupParticipants"
          [multiple]="true"
          [placeholder]="'Select' | translate"
          [selectOnTab]="true"
          bindLabel="fullName"
          bindValue="userId"
          class="custom"
          formControlName="assignedTo"
        ></ng-select>
      }

      @if (taskType === TasksType.Individual) {
        <ng-select
          [items]="teamMembers"
          [multiple]="true"
          [placeholder]="'Select' | translate"
          [selectOnTab]="true"
          bindLabel="fullName"
          bindValue="id"
          class="custom"
          formControlName="assignedTo"
        ></ng-select>
      }

      <app-form-error [control]="form.get('assignedTo')" [name]="'Members' | translate"></app-form-error>
    </div>

    @if (isMobileView()) {
      <div class="mt-16">
        <app-button (click)="save()" [idleText]="subtask ? 'Update' : ('Add' | translate)" cssClass="button-primary button-full"></app-button>
      </div>
    }
    @if (!isMobileView()) {
      <div class="buttons-container mt-16">
        <app-button (click)="close()" [idleText]="'Cancel' | translate" cssClass="button-simple"></app-button>
        <app-button (click)="save()" [idleText]="subtask ? 'Update' : ('Add' | translate)" cssClass="button-primary"></app-button>
      </div>
    }
  </form>
</div>
